$(document).ready(function(){
  $('.slider-product').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='17' height='32' viewBox='0 0 17 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M15.4241 0.275665C15.7847 -0.0918885 16.3691 -0.0918885 16.7296 0.275665C17.0901 0.643219 17.0901 1.239 16.7296 1.60655L2.61096 16L16.7296 30.3934C17.0901 30.761 17.0901 31.3568 16.7296 31.7243C16.3691 32.0919 15.7847 32.0919 15.4241 31.7243L0 16L15.4241 0.275665Z' fill='#6F9177'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='18' height='32' viewBox='0 0 18 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.6066 31.7243C1.23905 32.0919 0.643265 32.0919 0.275711 31.7243C-0.0918426 31.3568 -0.0918425 30.761 0.275711 30.3934L14.6692 16L0.275714 1.60655C-0.0918399 1.239 -0.0918399 0.643219 0.275714 0.275666C0.643268 -0.0918899 1.23905 -0.0918898 1.6066 0.275666L17.3309 16L1.6066 31.7243Z' fill='#6F9177'/></svg></button>",
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });
});
lightbox.option({
      'resizeDuration': 700,
      'wrapAround': true,
      'fadeDuration': 400,
      'imageFadeDuration': 400
    });
 document.addEventListener('click', function(e) {
    if (e.target.classList.contains('qty-btn')) {
    const wrapper = e.target.closest('.quantity-wrapper');
    const input = wrapper.querySelector('.quantity-input');
    let value = parseInt(input.value);

    if (e.target.classList.contains('qty-plus')) {
        input.value = value + 1;
    } else if (e.target.classList.contains('qty-minus') && value > 1) {
        input.value = value - 1;
    }
    }
});